import styled from 'styled-components';

export const StyledHeader = styled.header`
    z-index: 10;
    box-shadow: ${({ theme }) => theme.shadow.high};
`;
